module.exports = __webpack_public_path__ + "static/img/Latrell-Mitchell.d8168ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Latrell-Mitchell.jpg
// module id = rY4Y
// module chunks = 0